<div
  class="hover:border-primary-300 cursor-pointer rounded-xl border-2 bg-neutral-100 p-1.5 hover:bg-primary-100"
  [ngClass]="{
    'border-neutral-200 hover:border-neutral-300': !selected(),
    'border-primary-500 hover:border-primary-600': selected(),
  }"
  (click)="selectDocument()"
>
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-3">
      @if (isUploading()) {
        <md-document-icon [documentType]="documentType.Other"></md-document-icon>
        <div class="font-bold text-neutral-300">{{ "medicalDocuments.label.uploadingDocument" | translate }}</div>
      } @else if (isAnalyzing()) {
        <md-document-icon
          [documentType]="aiDocument().type ? documentType[aiDocument().type] : documentType.Other"
          [processingStatus]="aiDocument().processingStatus"
        ></md-document-icon>
        <div class="flex flex-col font-bold text-neutral-300">
          <span>{{ "medicalDocuments.label.analyzingDocument" | translate }}</span>
          <span class="text-sm font-thin">{{ "medicalDocuments.label.analyzingPreview" | translate }}</span>
        </div>
      } @else {
        <md-document-icon
          [documentType]="aiDocument().type ? documentType[aiDocument().type] : documentType.Other"
          [processingStatus]="aiDocument().processingStatus"
        ></md-document-icon>
        <div class="flex w-full flex-col">
          <span class="text-xs text-neutral-300">{{ formatDate(aiDocument().documentDate) }}</span>
          <div class="max-w-[300px] overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold">
            {{ aiDocument().documentTitle }}
          </div>
          @if (aiDocument().healthManagerTags && aiDocument().healthManagerTags.length > 0) {
            <div class="mt-1 flex flex-wrap gap-1">
              @for (tag of aiDocument().healthManagerTags; track tag) {
                <span class="inline-flex items-center rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-600">
                  {{ tag }}
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
    @if (aiDocument().documentTitle && !isUploading()) {
      <button
        class="flex items-center justify-center rounded-full border-2 border-transparent bg-transparent p-1.5 hover:border-primary-500 hover:bg-neutral-100 hover:text-primary-500"
        [matMenuTriggerFor]="medicalDocumentMenu"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu
        #medicalDocumentMenu="matMenu"
        xPosition="before"
      >
        <button
          mat-menu-item
          class="flex items-center justify-center"
          (click)="openDetails()"
        >
          <mat-icon>drive_file_rename_outline</mat-icon>
          {{ "medicalDocuments.buttons.checkAndSave" | translate }}
        </button>
        <button
          mat-menu-item
          class="flex items-center justify-center"
          (click)="deleteMedicalDocument()"
        >
          <mat-icon>delete_outline</mat-icon>
          {{ "buttons.delete" | translate }}
        </button>
      </mat-menu>
    }
  </div>
</div>
